import { render } from "./CatsRounded.vue?vue&type=template&id=d882c742&scoped=true"
import script from "./CatsRounded.vue?vue&type=script&lang=js"
export * from "./CatsRounded.vue?vue&type=script&lang=js"

import "./CatsRounded.vue?vue&type=style&index=0&id=d882c742&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d882c742"]])

export default __exports__